import { IconSelectorBlock } from '../commonFragments';
import { gql } from '@apollo/client';
import { ExternalLinkBlock, InternalLinkBlock } from './link';
import { Offer } from './offer';

export const NavigationUSPBarItemBlock = gql(`
    fragment NavigationUSPBarItemBlock on NavigationUspBarItemRecord {
        __typename
        title
        location
    }
`);

export const NavigationUSPBarBlock = gql`
    fragment NavigationUSPBarBlock on NavigationUspBarRecord {
        __typename
        usps {
            ...NavigationUSPBarItemBlock
        }
        callToAction {
            ...InternalLinkBlock
            ...ExternalLinkBlock
        }
    }
    ${NavigationUSPBarItemBlock}
    ${InternalLinkBlock}
    ${ExternalLinkBlock}
`;

export const SecondaryNavigationItemSubItemBlock = gql`
    fragment SecondaryNavigationItemSubItemBlock on SecondaryNavigationItemSubItemRecord {
        __typename
        title
        icon {
            ...IconSelectorBlock
        }
        link {
            ... on CategoryRecord {
                __typename
                id
                title
                fullSlug
                children {
                    __typename
                    id
                    title
                    fullSlug
                    children {
                        __typename
                        id
                        title
                        fullSlug
                    }
                }
            }
            ...Offer
        }
    }
    ${IconSelectorBlock}
    ${Offer}
`;

export const SecondaryNavigationItemBlock = gql`
    fragment SecondaryNavigationItemBlock on SecondaryNavigationItemRecord {
        __typename
        title
        subItems {
            ...SecondaryNavigationItemSubItemBlock
        }
        callToAction {
            ...InternalLinkBlock
            ...ExternalLinkBlock
        }
    }
    ${SecondaryNavigationItemSubItemBlock}
    ${InternalLinkBlock}
    ${ExternalLinkBlock}
`;

export const SecondaryNavigationBlock = gql`
    fragment SecondaryNavigationBlock on SecondaryNavigationRecord {
        __typename
        leftSection {
            ...SecondaryNavigationItemBlock
        }
        rightSection {
            ...SecondaryNavigationItemBlock
        }
    }
    ${SecondaryNavigationItemBlock}
`;

export const ProductNavigationItemBlock = gql`
    fragment ProductNavigationItemBlock on ProductNavigationItemRecord {
        __typename
        title
        link {
            ... on CategoryRecord {
                __typename
                id
                title
                fullSlug
                children {
                    __typename
                    id
                    title
                    fullSlug
                    children {
                        __typename
                        id
                        title
                        fullSlug
                    }
                }
            }
            ...Offer
        }
    }
    ${Offer}
`;

export const ProductNavigationBlock = gql`
    fragment ProductNavigationBlock on ProductNavigationRecord {
        __typename
        primaryItem {
            ...ProductNavigationItemBlock
        }
        items {
            ...ProductNavigationItemBlock
        }
    }
    ${ProductNavigationItemBlock}
`;

export const GlobalBannerBlock = gql`
    fragment GlobalBannerBlock on GlobalBannerRecord {
        id
        title
        body
        variant
        link {
            ...ExternalLinkBlock
            ...InternalLinkBlock
        }
        visibleFrom
        visibleUntil
        isCloseable
        visibleOn
    }
    ${ExternalLinkBlock}
    ${InternalLinkBlock}
`;

export const UldNavigationItemBlock = gql`
    fragment UldNavigationItemBlock on UldNavigationItemRecord {
        __typename
        id
        title
        links {
            ...ExternalLinkBlock
            ...InternalLinkBlock
        }
    }
    ${ExternalLinkBlock}
    ${InternalLinkBlock}
`;

export const UldNavigationBlock = gql`
    fragment UldNavigationBlock on UldNavigationRecord {
        __typename
        items {
            ...ExternalLinkBlock
            ...InternalLinkBlock
            ...UldNavigationItemBlock
        }
    }
    ${ExternalLinkBlock}
    ${InternalLinkBlock}
    ${UldNavigationItemBlock}
`;

export const NavigationFragment = gql`
    fragment Navigation on NavigationRecord {
        __typename
        logo {
            url
        }
        uspBar {
            ...NavigationUSPBarBlock
        }
        globalBanners {
            ...GlobalBannerBlock
        }
        uldNavigation {
            ...UldNavigationBlock
        }
    }
    ${NavigationUSPBarBlock}
    ${GlobalBannerBlock}
    ${UldNavigationBlock}
`;
